/* 360° strain explorer (snippets/elevana-strain-3d.liquid).
   Drag sideways to spin the bud, up/down to flip it. Each side opens a different panel:
   potency, terpenes, genetics, flavor (spin) and effects, lab report (flip).
   Frames live in Shopify Files: <base><seq>-m00.webp … (motion, 1080 px, every 5°) and
   <seq>-h00.webp … (native resolution, every 10°) which fade in whenever the bud comes to rest.
   Everything is inside this IIFE: the page's other scripts share one global scope. */
(function () {
  var root = document.querySelector('[data-s3d]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  var C = JSON.parse(root.querySelector('.s3d-data').textContent);
  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
  var stage = $('.s3d-stage'), cv = $('.s3d-cv'), ctx = cv.getContext('2d'), hiImg = $('.s3d-hi');
  var loadEl = $('.s3d-load'), hint = $('.s3d-hint'), sideName = $('.s3d-side-name'), sideIcon = $('.s3d-side i'), degEl = $('.s3d-deg');
  var CROP = C.crop || 1;                    // frames are drawn zoomed in so the bud fills more of the stage
  stage.style.setProperty('--s3d-s', (1 / CROP).toFixed(4));
  var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  var META = {
    potency: { icon: '⚡', label: 'Potency' }, terps: { icon: '🌿', label: 'Terpenes' },
    genetics: { icon: '🧬', label: 'Genetics' }, flavor: { icon: '🍪', label: 'Flavor' },
    effects: { icon: '✨', label: 'Effects' }, lab: { icon: '🔬', label: 'Lab report' }
  };
  var FAC = C.facets;                       // [{k, seq, a}] a = angle in degrees along that clip
  var KEYS = FAC.map(function (f) { return f.k; });
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var pad = function (i) { return (i < 10 ? '0' : '') + i; };
  var url = function (seq, kind, i) { return C.base + seq + '-' + kind + pad(i) + '.webp' + (C.q || ''); };

  /* ---------------- panels + pins + dock (built from the data block) ---------------- */
  var L = C.lab || {};
  var num = function (v) { return (+v).toFixed(2).replace(/\.?0+$/, ''); };
  var bar = function (name, v, max) { return '<div class="s3d-bar"><span>' + name + '</span><div><i style="--w:' + Math.max(2, v / max * 100).toFixed(1) + '%"></i></div><b>' + num(v) + '%</b></div>'; };
  var FLAV = { bakery: '🥐', dessert: '🍰', earthy: '🌱', spicy: '🌶️', minty: '🌿', sweet: '🍬', citrus: '🍋', fruity: '🍓', berry: '🫐', diesel: '⛽', gas: '⛽', pine: '🌲', floral: '🌸', herbal: '🌿', creamy: '🍦', vanilla: '🍦', grape: '🍇', lemon: '🍋', tropical: '🥭', woody: '🪵', pepper: '🌶️', garlic: '🧄', cheese: '🧀', skunk: '🦨', nutty: '🥜', coffee: '☕', chocolate: '🍫' };
  var flavIcon = function (f) { return FLAV[String(f).toLowerCase().trim()] || '•'; };
  var P = {};
  var max = Math.max(+L.thca || 0, +L.total_cann || 0) * 1.08 || 30;
  P.potency = '<h3>Potency</h3><p>Straight from this batch&rsquo;s lab report, not a guess.</p>' +
    '<div class="s3d-big"><strong>' + num(L.thca) + '%</strong><span>THCa<small>lab tested</small></span></div>' +
    '<div class="s3d-bars">' + bar('THCa', L.thca, max) + bar('Total THC', L.total_thc, max) + bar('Total cannabinoids', L.total_cann, max) +
    (+L.cbg ? bar('CBG', L.cbg, max) : '') + (+L.d9 ? bar('&Delta;9-THC', L.d9, max) : '') + (+L.cbd ? bar('CBD', L.cbd, max) : '') + '</div>' +
    '<div class="s3d-tags" style="margin-top:16px">' + (C.potency ? '<span class="s3d-tag hot">Potency: ' + esc(C.potency) + '</span>' : '') +
    (C.type ? '<span class="s3d-tag">' + esc(C.type) + '</span>' : '') + ''  /* Sep 14: no batch numbers on the site */ + '</div>' +
    '<div class="s3d-how"><b>How it works:</b> drag the bud sideways to spin it, up or down to flip it. Every side unlocks something new. Flip it upside down for the lab report.</div>';
  P.terps = '<h3>Terpenes</h3><p>The aroma compounds behind the ' + esc(C.nose || 'nose') + '.</p>' +
    (C.terps || []).map(function (t) {
      var lv = ''; for (var i = 0; i < 3; i++) lv += '<u class="' + (i < t.level ? 'f' : '') + '"></u>';
      return '<div class="s3d-terp"><i style="--c:' + esc(t.color) + '">' + esc(t.icon) + '</i><div><b>' + esc(t.name) + '</b><span>' + esc(t.note) + '</span><span>Also in ' + esc(t.also) + '</span></div><div class="s3d-lvl" title="Relative strength">' + lv + '</div></div>';
    }).join('') + (C.terp_note ? '<div class="s3d-how">' + esc(C.terp_note) + '</div>' : '');
  P.genetics = '<h3>Genetics</h3><p>' + esc(C.tagline || '') + '</p>' +
    '<div class="s3d-tree"><div class="s3d-par"><small>Parent</small>' + esc((C.parents || [])[0]) + '</div><div class="s3d-x">&times;</div><div class="s3d-par"><small>Parent</small>' + esc((C.parents || [])[1]) + '</div>' +
    '<div class="s3d-kid">' + esc(C.name) + '</div></div>' +
    '<div class="s3d-specs">' + (C.type ? '<div><small>Type</small>' + esc(C.type) + '</div>' : '') + (C.cultivation ? '<div><small>Cultivation</small>' + esc(C.cultivation) + '</div>' : '') +
    (C.origin ? '<div><small>Origin</small>' + esc(C.origin) + '</div>' : '') + (C.reviews ? '<div><small>Reviews</small>&#9733; ' + esc(C.rating) + ' &middot; ' + esc(C.reviews) + '</div>' : '') + '</div>';
  P.flavor = '<h3>Flavor</h3><p>' + esc(C.flavor_line || '') + '</p><div class="s3d-tags">' +
    (C.flavors || []).map(function (f, i) { return '<span class="s3d-tag' + (i < 2 ? ' hot' : '') + '">' + flavIcon(f) + ' ' + esc(f) + '</span>'; }).join('') + '</div>';
  P.effects = '<h3>Effects</h3><p>How it tends to land.</p><div class="s3d-eff">' +
    (C.effects || []).map(function (e) { var m = String(e).match(/^(\S+)\s+(.*)$/); return '<div><i>' + esc(m ? m[1] : '✨') + '</i>' + esc(m ? m[2] : e) + '</div>'; }).join('') + '</div>' +
    ((C.ideal || []).length ? '<div class="s3d-pk" style="margin-bottom:10px">Best for</div><div class="s3d-tags">' + C.ideal.map(function (x) { return '<span class="s3d-tag">' + esc(x) + '</span>'; }).join('') + '</div>' : '');
  P.lab = '<h3>Lab report</h3><p>You flipped it. Here&rsquo;s everything underneath: tested by ' + esc(L.lab || 'a licensed lab') + ''  /* Sep 14: no test dates on the site */ + '.</p>' +
    '<div class="s3d-tests">' + (L.tests || []).map(function (t) { return '<div><span>' + esc(t[0]) + '</span><b>' + esc(t[1]) + '</b></div>'; }).join('') + '</div>' +
    (L.coa ? '<a class="s3d-coa" href="' + esc(L.coa) + '" target="_blank" rel="noopener">View the full COA (PDF) &rarr;</a>' : '');

  $('.s3d-body').innerHTML = KEYS.map(function (k) { return '<section class="s3d-pn" data-k="' + k + '" aria-label="' + META[k].label + '">' + (P[k] || '') + '</section>'; }).join('');
  $('.s3d-dock').innerHTML = KEYS.map(function (k) { return '<button type="button" class="s3d-chip" data-k="' + k + '" aria-label="Show ' + META[k].label + '"><i>' + META[k].icon + '</i>' + META[k].label.split(' ')[0] + '</button>'; }).join('');
  $('.s3d-prog span').innerHTML = KEYS.map(function () { return '<u></u>'; }).join('');
  $('.s3d-pins').innerHTML = KEYS.map(function (k) {
    return '<div class="s3d-pg" data-k="' + k + '">' + ((C.pins || {})[k] || []).map(function (p) {
      return '<div class="s3d-pin' + (p.side === 'l' ? ' l' : '') + '" data-side="' + (p.side === 'l' ? 'l' : 'r') + '" style="--x:' + p.x + '%;--y:' + p.y + '%"><i></i><u></u><span>' + esc(p.t) + (p.s ? '<small>' + esc(p.s) + '</small>' : '') + '</span></div>';
    }).join('') + '</div>';
  }).join('');
  var pgs = {}; $$('.s3d-pg').forEach(function (g) { pgs[g.dataset.k] = g; });

  /* ---------------- frames ---------------- */
  var F = { spin: { m: [], h: [] }, flip: { m: [], h: [] } };
  var N = function (s) { return C.seq[s].n; };
  var ordered = function (n) {
    var out = [], seen = {};
    [n / 2, n / 4, n / 8, 3, 1].forEach(function (st) { st = Math.max(1, Math.round(st)); for (var i = 0; i < n; i += st) if (!seen[i]) { seen[i] = 1; out.push(i); } });
    return out;
  };
  var queue = [], active = 0, started = false, loadedSpin = 0, ready = false;
  function fetchImg(src, cb) {
    var im = new Image(); im.decoding = 'async';
    im.onload = function () { (im.decode ? im.decode() : Promise.resolve()).catch(function () {}).then(function () { cb(im); }); };
    im.onerror = function () { cb(null); };
    im.src = src;
  }
  function pump() {
    while (active < 6 && queue.length) {
      var job = queue.shift(); active++;
      (function (job) {
        fetchImg(url(job.s, job.kind, job.i), function (im) {
          active--;
          if (im) {
            F[job.s][job.kind][job.i] = im;
            if (job.s === 'spin' && job.kind === 'm') { loadedSpin++; progress(); }
            dirty = true;
          }
          pump();
        });
      })(job);
    }
  }
  function startLoading() {
    if (started) return; started = true;
    queue.push({ s: 'spin', kind: 'h', i: 0 });
    ordered(N('spin')).forEach(function (i) { queue.push({ s: 'spin', kind: 'm', i: i }); });
    ordered(N('flip')).forEach(function (i) { queue.push({ s: 'flip', kind: 'm', i: i }); });
    // the rest frames at each side, so jumping from the dock lands sharp
    FAC.forEach(function (f) { var j = Math.round(f.a / 360 * N(f.seq) / 2) % (N(f.seq) / 2); if (!(f.seq === 'spin' && j === 0)) queue.push({ s: f.seq, kind: 'h', i: j }); });
    pump();
  }
  function progress() {
    var p = Math.min(100, Math.round(loadedSpin / (N('spin') / 4) * 100));
    loadEl.style.setProperty('--s3d-p', p); loadEl.querySelector('span').textContent = p + '%';
    if (!ready && p >= 100) { ready = true; loadEl.classList.add('done'); }
  }

  /* ---------------- state ---------------- */
  var seq = 'spin', pos = 0, vel = 0, drag = null, tweens = [], dirty = true, lastKey = '', inView = false;
  var attract = !reduced, lastInteract = 0, zoom = false, activeK = null, found = {}, complete = false, restSince = 0, hiKey = '';
  var wrap = function (v, n) { return ((v % n) + n) % n; };
  var wdist = function (a, b, n) { return wrap(b - a + n / 2, n) - n / 2; };

  function nearestFrame(s, i) {
    var n = N(s), arr = F[s].m;
    for (var d = 0; d <= n / 2; d++) { var a = arr[(i + d) % n]; if (a) return a; var b = arr[wrap(i - d, n)]; if (b) return b; }
    return s === 'spin' ? F.spin.h[0] : F.spin.m[0] || F.spin.h[0];
  }
  function draw() {
    var i = wrap(Math.round(pos), N(seq)), key = seq + i;
    if (key === lastKey && !dirty) return;
    var im = nearestFrame(seq, i);
    if (!im) return;
    var sw = im.naturalWidth * CROP, sx = (im.naturalWidth - sw) / 2;
    ctx.drawImage(im, sx, sx, sw, sw, 0, 0, cv.width, cv.height);
    lastKey = key; dirty = false;
  }
  // labels sit beside their dot; on a narrow stage flip any that would run off the edge
  function fitPins() {
    var sr = stage.getBoundingClientRect(); if (!sr.width) return;
    $$('.s3d-pin').forEach(function (p) {
      p.classList.toggle('l', p.dataset.side === 'l');
      var r = p.querySelector('span').getBoundingClientRect();
      if (p.dataset.side !== 'l' && r.right > sr.right - 8) p.classList.add('l');
      if (p.dataset.side === 'l' && r.left < sr.left + 8) p.classList.remove('l');
    });
  }
  function size() {
    var d = Math.min(window.devicePixelRatio || 1, 2), w = Math.round((cv.clientWidth || stage.clientWidth) * d);   /* the canvas is the square the bud is drawn in (whole stage, or centred in a wide compact stage) */
    if (cv.width !== w) { cv.width = cv.height = w; ctx.imageSmoothingQuality = 'high'; dirty = true; fitPins(); }
  }

  function angle() { return wrap(pos, N(seq)) / N(seq) * 360; }
  function detect() {
    var a = angle(), best = null, bd = 999;
    FAC.forEach(function (f) {
      var fa = f.seq === seq ? f.a : (f.k === 'potency' ? 0 : null);
      if (fa === null) return;
      var d = Math.abs(wrap(a - fa + 180, 360) - 180);
      if (d < bd) { bd = d; best = f.k; }
    });
    return { k: best, d: bd };
  }
  function setActive(k) {
    if (k === activeK) return; activeK = k;
    $$('.s3d-pn').forEach(function (p) { p.classList.toggle('on', p.dataset.k === k); });
    $$('.s3d-chip').forEach(function (c) { c.classList.toggle('on', c.dataset.k === k); });
    sideName.textContent = META[k].label; sideIcon.textContent = META[k].icon;
    $('.s3d-pk em').textContent = 'Side ' + (KEYS.indexOf(k) + 1) + ' of ' + KEYS.length;
  }
  function markFound(k) {
    if (found[k]) return; found[k] = 1;
    var n = Object.keys(found).length;
    root.querySelector('.s3d-chip[data-k="' + k + '"]').classList.add('found');
    $$('.s3d-prog u').forEach(function (u, i) { u.classList.toggle('f', i < n); });
    $('.s3d-prog b').textContent = n + ' of ' + KEYS.length;
    if (n === KEYS.length && !complete) { complete = true; root.classList.add('complete'); burst(); }
  }
  function burst() {
    if (reduced) return;
    var b = document.createElement('div'); b.className = 's3d-burst';
    for (var i = 0; i < 16; i++) { var s = document.createElement('i'), a = i / 16 * Math.PI * 2, r = 150 + Math.random() * 90; s.style.setProperty('--dx', Math.cos(a) * r + 'px'); s.style.setProperty('--dy', Math.sin(a) * r + 'px'); s.style.animationDelay = (Math.random() * .15) + 's'; b.appendChild(s); }
    stage.appendChild(b); setTimeout(function () { b.remove(); }, 1500);
  }

  /* hi-res: once the bud is still on an even frame, fade the native-resolution frame over it */
  function hiFor(s, i) { return F[s].h[i / 2]; }
  function updateHi(now, resting) {
    var i = wrap(Math.round(pos), N(seq));
    if (!resting || i % 2) { if (!zoom && hiImg.classList.contains('on')) hiImg.classList.remove('on'); hiKey = ''; return; }
    var key = seq + i;
    if (hiKey === key) return;
    var have = hiFor(seq, i);
    if (have) { hiImg.src = have.src; hiImg.classList.add('on'); hiKey = key; return; }
    if (now - restSince < 120) return;
    hiKey = key + ':loading';
    var s = seq;
    fetchImg(url(s, 'h', i / 2), function (im) { if (im) F[s].h[i / 2] = im; hiKey = ''; });
  }

  /* ---------------- motion ---------------- */
  function stopAttract() { attract = false; }
  function interacted() {
    stopAttract(); lastInteract = performance.now();
    if (hint && !hint.classList.contains('gone')) hint.classList.add('gone');
  }
  function goHome() { tweens.push({ to: 0 }); }
  function goFacet(k) {
    var f = FAC.filter(function (x) { return x.k === k; })[0]; if (!f) return;
    interacted(); if (zoom) setZoom(false);
    tweens.length = 0; vel = 0;
    if (f.seq !== seq) { goHome(); tweens.push({ sw: f.seq }); }
    tweens.push({ to: f.a / 360 * N(f.seq) });
  }
  function runTween(now) {
    var t = tweens[0]; if (!t) return;
    if (t.sw) { seq = t.sw; pos = 0; tweens.shift(); dirty = true; return; }
    var n = N(seq);
    if (t.t0 === undefined) { t.from = pos; t.d = wdist(pos, t.to, n); t.t0 = now; t.dur = Math.max(240, Math.min(1150, Math.abs(t.d) / n * 2400)); }
    var k = Math.min(1, (now - t.t0) / t.dur), e = k < .5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;
    pos = t.from + t.d * e;
    if (k >= 1) tweens.shift();
  }
  function setZoom(on) {
    zoom = on; stage.classList.toggle('zoom', on);
    if (on) {
      interacted(); tweens.length = 0; vel = 0;
      var i = wrap(Math.round(pos), N(seq)); if (i % 2) i = wrap(i + 1, N(seq)); pos = i;
      var have = hiFor(seq, i);
      if (have) hiImg.src = have.src; else fetchImg(url(seq, 'h', i / 2), function (im) { if (im) { F[seq].h[i / 2] = im; if (zoom) hiImg.src = im.src; } });
      hiImg.classList.add('on');
    }
  }

  var prev = 0;
  function frame(now) {
    requestAnimationFrame(frame);
    var dt = Math.min(.05, (now - (prev || now)) / 1000); prev = now;
    if (!inView) return;
    var n = N(seq), resting = false;
    if (zoom) { draw(); return; }
    if (tweens.length) runTween(now);
    else if (drag) { /* position set by pointer */ }
    else if (attract) { if (seq === 'spin' && ready) pos += dt * n / 13; }
    else if (Math.abs(vel) > 1.2) { pos += vel * dt; vel *= Math.exp(-dt * 3.2); }
    else {
      vel = 0;
      var target = Math.round(pos / 2) * 2, d = target - pos;
      if (Math.abs(d) > .01) pos += d * Math.min(1, dt * 12); else { pos = target; resting = true; }
    }
    pos = wrap(pos, n);
    if (!resting) restSince = now;
    draw();
    updateHi(now, resting);

    var det = detect(), k = Math.max(0, 1 - det.d / 30);
    if (det.d < 40) setActive(det.k);
    if (det.d < 16 && !attract && !tweens.length) markFound(det.k);   // passing a side on the way to another doesn't count
    if (det.d < 16 && attract && det.k === 'potency') markFound('potency');
    KEYS.forEach(function (key) { var g = pgs[key], v = key === det.k ? k : 0; if (g._v !== v) { g._v = v; g.style.opacity = v; g.style.setProperty('--s3d-k', v); } });
    var a = Math.round(angle());
    degEl.textContent = (seq === 'spin' ? 'SPIN ' : 'FLIP ') + ('00' + a).slice(-3) + '°';
  }

  /* ---------------- input ---------------- */
  stage.addEventListener('pointerdown', function (e) {
    if (e.button > 0 || e.target.closest('button,a')) return;
    if (zoom) { setZoom(false); return; }
    drag = { x0: e.clientX, y0: e.clientY, x: e.clientX, y: e.clientY, t: performance.now(), axis: null };
    try { stage.setPointerCapture(e.pointerId); } catch (_) {}
    stage.classList.add('dragging'); interacted(); tweens.length = 0; vel = 0;
  });
  stage.addEventListener('pointermove', function (e) {
    var r = stage.getBoundingClientRect(), fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
    if (zoom) {
      var hx = (e.clientX - r.left - hiImg.offsetLeft) / (hiImg.offsetWidth || r.width), hy = (e.clientY - r.top - hiImg.offsetTop) / (hiImg.offsetHeight || r.height);
      stage.style.setProperty('--s3d-ox', (hx * 100).toFixed(1) + '%'); stage.style.setProperty('--s3d-oy', (hy * 100).toFixed(1) + '%'); return;
    }
    stage.style.setProperty('--s3d-px', ((fx - .5) * -16).toFixed(1) + 'px'); stage.style.setProperty('--s3d-py', ((fy - .5) * -16).toFixed(1) + 'px');
    if (!drag) return;
    var now = performance.now(), dx = e.clientX - drag.x, dy = e.clientY - drag.y;
    drag.x = e.clientX; drag.y = e.clientY;
    if (!drag.axis) {
      var tx = e.clientX - drag.x0, ty = e.clientY - drag.y0;
      if (Math.hypot(tx, ty) < 6) return;
      drag.axis = Math.abs(tx) >= Math.abs(ty) ? 'spin' : 'flip';
      if (drag.axis !== seq) { goHome(); tweens.push({ sw: drag.axis }); }
    }
    if (tweens.length) { drag.t = now; return; }
    var n = N(seq), px = drag.axis === 'spin' ? dx : dy;
    var d = px / (Math.min(r.width, r.height) * 1.3) * n * (C.seq[seq].dir || 1);
    pos += d;
    var dt = Math.max(8, now - drag.t) / 1000; drag.t = now;
    vel = vel * .55 + (d / dt) * .45;
    vel = Math.max(-n * 1.6, Math.min(n * 1.6, vel));
    stage.style.setProperty('--s3d-tilt', drag.axis === 'spin' ? Math.max(-3, Math.min(3, vel / n * 3)).toFixed(2) + 'deg' : '0deg');
  });
  function endDrag() {
    if (!drag) return;
    if (performance.now() - drag.t > 90) vel = 0;       // held still before letting go: no fling
    drag = null; stage.classList.remove('dragging'); lastInteract = performance.now();
    stage.style.setProperty('--s3d-tilt', '0deg');
  }
  stage.addEventListener('pointerup', endDrag);
  stage.addEventListener('pointercancel', endDrag);
  stage.addEventListener('lostpointercapture', endDrag);
  stage.addEventListener('keydown', function (e) {
    var map = { ArrowLeft: ['spin', -1], ArrowRight: ['spin', 1], ArrowUp: ['flip', -1], ArrowDown: ['flip', 1] }[e.key];
    if (e.key === 'Escape' && zoom) { setZoom(false); return; }
    if (!map) return;
    e.preventDefault(); interacted(); vel = 0;
    if (tweens.length) return;
    if (map[0] !== seq) { goHome(); tweens.push({ sw: map[0] }); }
    var n = N(map[0]), base = map[0] === seq ? pos : 0;
    tweens.push({ to: wrap(Math.round((base + map[1] * n / 12) / 2) * 2, n) });
  });
  root.addEventListener('click', function (e) {
    var chip = e.target.closest('.s3d-chip'); if (chip) { goFacet(chip.dataset.k); return; }
    if (e.target.closest('.s3d-btn.z')) { setZoom(!zoom); return; }
    if (e.target.closest('.s3d-btn.r')) { goFacet('potency'); return; }
    var cta = e.target.closest('.s3d-cta');
    if (cta) {
      if (cta.dataset.href) { window.location.href = cta.dataset.href; return; }   /* home page: go to the strain */
      var t = document.querySelector('#addBtn') || document.querySelector('.big-cta');
      if (t) t.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  /* ---------------- boot ---------------- */
  size(); window.addEventListener('resize', size);
  if (window.ResizeObserver) new ResizeObserver(size).observe(stage);
  setActive('potency'); markFound('potency');
  var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) startLoading(); }); }, { rootMargin: '900px 0px' });
  io.observe(root);
  var vio = new IntersectionObserver(function (es) { inView = es[0].isIntersecting; }, { threshold: .05 });
  vio.observe(stage);
  requestAnimationFrame(frame);
  window.__s3d = { go: goFacet, state: function () { return { seq: seq, pos: pos, angle: angle(), active: activeK, found: Object.keys(found), ready: ready, hi: hiImg.classList.contains('on'), zoom: zoom }; }, zoom: setZoom };
})();
